import {LeftNavigation} from "../../Components/Navigation/LeftNavigation";
import React, {useState} from "react";
import {Presales} from "../Presales/Presales";
import {Terms} from "../Terms/Terms";
import {useParams} from "react-router-dom";
import {Orders} from "../Orders/Orders";
import {useGlobalDataContext} from "../../GlobalState/GlobalDataProvider";
import {ExplanationModal} from "../../Components/System/Messages/ExplanationModal";
import {NewVersionAvailable} from "../../Components/System/Messages/NewVersionAvailable";
import {useDisclosure} from "@mantine/hooks";
import {MyCarzelle} from "../MyCarzelle/MyCarzelle";
import {DashboardPagesEnum} from "../../Enums/DashboardPagesEnum";
import {Showroom} from "../Showroom/Showroom";

export const Dashboard = () => {
    const [updateData] = useState(false);
    const {fetchGlobalData, showroomMode} = useGlobalDataContext();
    const {menuItem} = useParams();
    const [opened, {close}] = useDisclosure(false);

    return (
        <div className="min-h-screen">
            {/*<ScreenSizeIndicator/>*/}
            <div className="hidden screen-small:block">
                <LeftNavigation chosenMenuItemId={menuItem} showroomMode={showroomMode}/>
            </div>

            <div className="screen-small:pb-4 screen-small:pl-4 screen-small:ml-14">
                {menuItem === DashboardPagesEnum.mycarzelle && <div className="ml-10 mt-10 text-4xl font-bold"><MyCarzelle selected={menuItem === DashboardPagesEnum.mycarzelle}/></div>}
                {/*{menuItem === DashboardPagesEnum.showroom && <div><AvailableCars fnUpdate={fetchGlobalData} basketData={basketData} showSearch={true} showroomMode={false} selected={menuItem === DashboardPagesEnum.showroom}/></div>}*/}
                {menuItem === DashboardPagesEnum.carlist && <div>
                    <div className="screen-small:block"><Presales fnUpdateGlobalData={fetchGlobalData} pushUpdate={updateData}/></div>
                </div>}
                {menuItem === DashboardPagesEnum.orderview && <div className="h-full max-h-screen overflow-auto"><Orders selected={menuItem === DashboardPagesEnum.orderview}/></div>}
                {menuItem === DashboardPagesEnum.terms && <div className="h-full max-h-screen overflow-auto"><Terms selected={menuItem === DashboardPagesEnum.terms}/></div>}
                {menuItem === DashboardPagesEnum.room && <div className="h-full max-h-screen overflow-auto"><Showroom selected={menuItem === DashboardPagesEnum.room}/></div>}
            </div>

            <ExplanationModal HelpComponent={<NewVersionAvailable/>} opened={opened} close={close} title="New version"/>
        </div>
    )
}